import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
/* eslint-disable no-nested-ternary */
import React, { useCallback, useContext, useEffect, useState, useRef, useMemo } from 'react';
import { styled } from '@mui/material/styles';
import { localizationContext } from '../localizationContext';
import { EditTranslateModal } from './EditTranslateModal';
import { redirectToTranslationEditor } from './api-customize-hooks';
import parse from 'html-react-parser';
import html2canvas from 'html2canvas';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function EditTranslate(props) {
  var _ref2;
  var params = props.params,
    paramsWithDangerousHtml = props.paramsWithDangerousHtml,
    text = props.text;
  var context = useContext(localizationContext);
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    translated = _useState2[0],
    setTranslated = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    displayValue = _useState4[0],
    setDisplayValue = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    open = _useState6[0],
    setOpen = _useState6[1];
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    errorMessage = _useState8[0],
    setErrorMessage = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showPleaseWaitLabel = _useState10[0],
    setShowPleaseWaitLabel = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showPleaseWaitLabelOnSave = _useState12[0],
    setShowPleaseWaitLabelOnSave = _useState12[1];
  var _useState13 = useState(undefined),
    _useState14 = _slicedToArray(_useState13, 2),
    previewValue = _useState14[0],
    setPreviewValue = _useState14[1];
  var _useState15 = useState(undefined),
    _useState16 = _slicedToArray(_useState15, 2),
    displayPreviewValue = _useState16[0],
    setDisplayPreviewValue = _useState16[1];
  var selectedValue = useRef(null);
  var convertStringToTranslation = useCallback(function (str) {
    for (var key in params) {
      str = str.replace("{{".concat(key, "}}"), params[key]);
    }
    return str;
  }, [params]);
  useEffect(function () {
    var isActive = true;
    if (context) {
      context.localizationService.translate(text, {
        returnKeyIfNotFound: false
      }).then(function (res) {
        if (isActive && res) {
          setTranslated(res);
          if (params) res = convertStringToTranslation(res);
          setDisplayValue(paramsWithDangerousHtml ? parse(res) : res);
        }
      })["catch"]();
    }
    return function () {
      isActive = false;
    };
  }, [context, text, params, convertStringToTranslation, paramsWithDangerousHtml]);
  var handleClose = function handleClose() {
    setErrorMessage(undefined);
    setOpen(false);
  };
  var handleClick = function handleClick(e) {
    e.preventDefault();
    setShowPleaseWaitLabel(false);
    setShowPleaseWaitLabelOnSave(false);
    setOpen(true);
  };
  var onPreviewHandle = function onPreviewHandle(valueSelected) {
    if (!valueSelected) {
      setErrorMessage('Please enter translation to PREVIEW');
      return;
    }
    var newDisplayTranslation = parse(params ? convertStringToTranslation(valueSelected) : valueSelected);
    if (newDisplayTranslation === displayValue) {
      setErrorMessage('Please modify the translation to PREVIEW');
      return;
    }
    setPreviewValue(valueSelected);
    setDisplayPreviewValue(newDisplayTranslation);
    setOpen(false);
  };
  var onRaiseRequestHandle = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _selectedValue$curren, _selectedValue$curren2;
      var rect, currentPosition, canvas, image;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            selectedValue == null ? void 0 : (_selectedValue$curren = selectedValue.current) == null ? void 0 : _selectedValue$curren.classList.add('requested-translation');
            setShowPleaseWaitLabel(true);
            rect = document.body.getBoundingClientRect();
            currentPosition = rect.top + window.scrollY;
            _context.next = 6;
            return html2canvas(document.body, {
              height: window.innerHeight,
              ignoreElements: function ignoreElements(element) {
                if (element.tagName === 'NOSCRIPT' || element.id === 'showHideKeysFloatingBtn') {
                  return true;
                } else {
                  return false;
                }
              },
              onclone: function onclone(clonedDoc) {
                var _clonedDoc$querySelec;
                var modifiedSpans = clonedDoc.querySelectorAll('.modified-translation');
                modifiedSpans.forEach(function (element) {
                  var originalValue = element.getAttribute('data-original-value');
                  if (originalValue) element.innerHTML = originalValue;
                  element.classList.remove('modified-translation');
                });
                (_clonedDoc$querySelec = clonedDoc.querySelector('.requested-translation')) == null ? void 0 : _clonedDoc$querySelec.classList.add('hover');
              },
              width: window.innerWidth,
              y: currentPosition
            });
          case 6:
            canvas = _context.sent;
            image = canvas.toDataURL('image/png', 1.0);
            selectedValue == null ? void 0 : (_selectedValue$curren2 = selectedValue.current) == null ? void 0 : _selectedValue$curren2.classList.remove('requested-translation');
            redirectToTranslationEditor({
              App: context == null ? void 0 : context.localizationService.AppName,
              Data: [{
                ResourceKey: text,
                value: image
              }],
              Locale: context == null ? void 0 : context.locale,
              RequestType: 'Add'
            }, "https://translations.corporate.ingrammicro.com/Requests/Add").then(function () {
              setOpen(false);
            })["catch"](function (error) {
              setErrorMessage(error.message);
              setShowPleaseWaitLabel(false);
            });
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onRaiseRequestHandle() {
      return _ref.apply(this, arguments);
    };
  }();
  var onResetHandle = function onResetHandle() {
    setPreviewValue(undefined);
    setDisplayPreviewValue(undefined);
    setErrorMessage(undefined);
    setOpen(false);
  };
  var onSaveHandleClick = function onSaveHandleClick(valueSaved, translationKey) {
    if (!valueSaved) {
      setErrorMessage('Please enter translation to SAVE');
      return;
    }
    var newDisplayTranslation = parse(params ? convertStringToTranslation(valueSaved) : valueSaved);
    if (newDisplayTranslation === displayValue) {
      setErrorMessage('Please modify the translation to SAVE');
      return;
    }
    setShowPleaseWaitLabelOnSave(true);
    redirectToTranslationEditor({
      App: context == null ? void 0 : context.localizationService.AppName,
      Data: [{
        ResourceKey: text,
        value: valueSaved
      }],
      Locale: context == null ? void 0 : context.locale,
      RequestType: 'Edit'
    }, "https://translations.corporate.ingrammicro.com/Translations/Add").then(function () {
      setPreviewValue(valueSaved);
      setDisplayPreviewValue(newDisplayTranslation);
      setOpen(false);
    })["catch"](function (error) {
      setErrorMessage(error.message);
      setShowPleaseWaitLabelOnSave(false);
    });
  };
  var clearErrorMessage = function clearErrorMessage() {
    setErrorMessage(undefined);
  };
  var isTranslationModified = useMemo(function () {
    if (displayValue && displayPreviewValue && displayPreviewValue !== displayValue) {
      return true;
    } else {
      return false;
    }
  }, [displayValue, displayPreviewValue]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [translated ? /*#__PURE__*/_jsx(StyleSpan, {
      className: isTranslationModified ? 'modified-translation' : '',
      "data-original-value": params ? convertStringToTranslation(translated) : translated,
      onContextMenu: function onContextMenu(e) {
        return handleClick(e);
      },
      ref: selectedValue,
      children: context != null && context.isShowKeyEnabled ? text : previewValue ? displayPreviewValue : displayValue
    }) : text, /*#__PURE__*/_jsx(EditTranslateModal, {
      clearErrorMessage: clearErrorMessage,
      errorMessage: errorMessage,
      onClose: handleClose,
      onPreviewChange: onPreviewHandle,
      onRaiseRequestChange: onRaiseRequestHandle,
      onResetHandleChange: onResetHandle,
      onSaveHandleChange: onSaveHandleClick,
      open: open,
      showPleaseWaitLabel: showPleaseWaitLabel,
      showPleaseWaitLabelOnSave: showPleaseWaitLabelOnSave,
      showRequestButton: context !== undefined && !context.locale.toLowerCase().startsWith('en-'),
      translationKey: text,
      translationValue: displayValue,
      value: (_ref2 = previewValue != null ? previewValue : translated) != null ? _ref2 : ''
    })]
  });
}
var StyleSpan = styled('span')(function () {
  return _defineProperty(_defineProperty(_defineProperty({}, "&.hover", {
    background: '#ffeb3b !important'
  }), "&.modified-translation", {
    background: '#e3fffa',
    color: '#18846f'
  }), ":hover", {
    background: '#ffeb3b !important'
  });
});